import { prefix } from '../../utils/prefix';

export default {
  // 很多接口需要换为v2，并且在保存的时候，是在外部list组件内，需要特殊判断
  getInfo: `${prefix}/info/educationsInfo/get`,
  // V3.0 需求升级获取数据接口为V2版本
  getInfoV2: `${prefix}/info/educationsInfo/v2/get`,

  // 草稿保存的接口，在List组件内部写死了，以前的方式太乱了，还不敢乱改
  saveDraft: `${prefix}/draft/educationsInfo/save`,
  save: `${prefix}/info/educationsInfo/save`,
  // V3.0 需求升级点击下一步的保存接口为V2版本
  saveV2: `${prefix}/info/educationsInfo/v2/save`,
  upload: `${prefix}/attachment/upload`, // 银行卡照片
  getNationality: `${prefix}/dataset/nationality`, // 获取国家
  getSchool: `${prefix}/dataset/school`, // 获取学校
  getEducationType: `${prefix}/dataset/educationType`, // 获取学历
  getMajor: `${prefix}/dataset/major`, // 获取专业
  getDegree: `${prefix}/dataset/degree`, // 获取学位
  getEducationNature: `${prefix}/dataset/educationNature`, // 获取教育性质
  getJoinDate: `${prefix}/info/basicInfo/get`, // 通过获取基本信息接口获取入职日期
  getWorkerType: `${prefix}/info/workerType`, // 获取入职人员类型
  getUnableReason: `${prefix}/dataset/get/unableReason`, // 获取无法上传的原因
  ocrEdu: `${prefix}/attachment/ocr/edu`, // 获取OCR识别的证书编码
};
